/**
 * Faceted search - Clear button
 *
 * Implements the functionality of the "Clear filters" -button
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let filters = document.querySelector('.js-faceted-search-filters');
    let clear_button = document.querySelector(
        '.js-faceted-search-clear-button'
    );
    let accordions_buttons = document.querySelectorAll(
        '.js-facet-accordion-button'
    );

    if (!form || !filters || !clear_button) {
        return;
    }

    function clearIndicators() {
        if (accordions_buttons) {
            accordions_buttons.forEach((button) => {
                button.setAttribute('aria-description', '');
                button.classList.remove('-fields-modified');

                let indicator = button.querySelector(
                    '.js-faceted-search-accordion-indicator'
                );
                if (indicator) {
                    indicator.innerHTML = '';
                }
            });
        }
    }

    function clearFieldValues() {
        filters.querySelectorAll('input[type=checkbox]').forEach((checkbox) => {
            checkbox.checked = false;
        });
        filters.querySelectorAll('input[type=radio]').forEach((radio) => {
            radio.checked = false;
        });
    }

    function clearTextField() {
        let field = document.querySelector('.js-faceted-search-text-field');
        if (field) {
            field.value = '';
        }
    }

    clear_button.addEventListener('click', (e) => {
        e.preventDefault();
        clearFieldValues();
        clearIndicators();
        clearTextField();
        form.dispatchEvent(new Event('input'));
    });
})();
